const DoubleTick = () => {
  return (
    <svg
      width="17"
      height="10"
      viewBox="0 0 17 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 4.75L5.21875 5.21875M16 1L8.5 8.5L8.03125 8.03125"
        stroke="#121212"
        stroke-width="1.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 4.75L4.75 8.5L12.25 1"
        stroke="#121212"
        stroke-width="1.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export default DoubleTick;
